<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        {
          name: 'BU Page',
          to: {
            name: 'BUPage'
          }
        },
        {
          name: 'Create',
          to: {
            name: 'BUPageCreate',
            query: {
              section: $route.query.section,
            },
          }
        }
      ]"
    ></Breadscrumbs>

    <BUPAgeCreateEdit></BUPAgeCreateEdit>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BUPAgeCreateEdit from '@/views/B-3__BUPage/c/BUPageCreateEdit.vue';
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    BUPAgeCreateEdit,
    Breadscrumbs,
  },
  computed: {
    ...mapState('bupage', ['bu']),
  },
  created() {
    if (this.bu === null) {
      this.initBu();
    }
  },
  methods: {
    ...mapActions('bupage', {
      initBu: 'init',
    }),
  },
};
</script>
